import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Actions }from '../../Action/index';
import { updateCurationStatus, getQuestionDraftData, fetchAttachmentURL } from '../../API/api';
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

export default function CurationButtons({question, answer}) {
  const submitSuccessToast = (message) => {
    return (
      <>
        <span style={{ fontSize: "12px" }}>
          {message}
        </span>
      </>
    );
  };
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const {markedAnsweredData, updateSubmissionTypeForEditor, questionDataForEditor, updateAnswerTextForEditor} = bindActionCreators(Actions, dispatch)
    const expertAnsweredState = useSelector(state=>state.answeredQuestions);
    const userState = useSelector(state=>state.user);
    const editorState = useSelector(state=>state.editor);

    const onClickButton = (question, answer, key) => {
        var body = {
            answerUuidStr: answer.answerUuid,
            curationStatus: 'curated',
            evergreen: key === "evergreen"?true:false
         }
         let filteredData = expertAnsweredState.data.filter(obj=>{
            if(obj.questionUuid !== question.questionUuid){
                return obj;            
            }
         })
         updateCurationStatus(body).then(res=>{
          if (res===undefined) return;
          if(res.data.success){
            toast.success(submitSuccessToast(res.data.message), {
              position: toast.POSITION.TOP_RIGHT,
            });
            markedAnsweredData(filteredData);
          }
         })
    }
    const convertStringToEpoch = (dt) =>{
      let date = Date.parse(dt);
      return date;
    }
    const isAnsweredByMe = (arr) =>{
      let id = ""
      arr.filter(obj=>{
        if(obj.expertUuid === userState.geoAttributes.userId){
          id = obj.answerUuid;
        }
      })
      return id;
    }
    const appendInlineImageInText = async (arr) =>{
      let newArr = await arr.filter(obj=>{
        if(obj.expertUuid === userState.geoAttributes.userId){
          if(obj.inlineImages.length > 0){
            for (let i = 0; i < obj.inlineImages.length; ++i) {
              let pld= {name: obj.inlineImages[i]}
              fetchAttachmentURL(pld).then(res=>{
                if (res===undefined) return;
                if (obj.inlineImages[i].includes(".png")) {
                } else {
                  let imgTag = `<img style='max-width:50%' src=${
                    res.data.data.src
                  }></img>`;
    
                  let replacedContent = obj.inlineImages[i];
                  obj.answerCopy = obj.answerCopy.replaceAll(
                    replacedContent,
                    imgTag
                  );
                }
              })
            }
          }
          return obj;
        }
      })
      updateAnswerTextForEditor(newArr.length === 0?"":newArr[0].answerCopy);
    }
    const editAnswer = (question)=>{
      let data = question;
      if(data.questionText === undefined){
        data.questionText = data.question;
      }
      let isAnswerUuid = isAnsweredByMe(data.answers);
      editorState.answerUuid = isAnsweredByMe(data.answers);
      updateSubmissionTypeForEditor('update');
      data.questionPostedTimestamp = data.questionPostedTimestamp === undefined ?data.postedTimestamp:data.questionPostedTimestamp;
      data.questionStatus = 'answered';
      data.questionPostedTimestamp = typeof(data.questionPostedTimestamp)==='string'?convertStringToEpoch(data.questionPostedTimestamp):data.questionPostedTimestamp;
      questionDataForEditor(data);
        getQuestionDraftData(data.questionUuid).then(res=>{
          if (res===undefined) return;
          if(res.data.data.length > 0){
            updateAnswerTextForEditor(res.data.data[0].answer);
          }else{
            appendInlineImageInText(data.answers);
          }
        })
      navigate('/expertHome/editor');
    }
  return (
    <>
    <div>
    <button className='btn btn-primary videoshowbuttonAB' onClick={()=>editAnswer(question)}>Edit Answer</button>
    &nbsp;
    <button className='btn btn-primary videoshowbuttonAB' onClick={()=>onClickButton(question, answer, 'evergreen')}>Mark Evergreen</button>
    &nbsp;
    <button className='btn btn-primary videoshowbuttonAB' onClick={()=>onClickButton(question, answer, 'curated')}>Mark Curated</button>
    </div>
    </>
  )
}
